import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '..';

const Container = ({ children, ...props }) => (
  <Grid {...props}>{children}</Grid>
);

Container.propTypes = {
  /** The contents of the container */
  children: PropTypes.any,
};

Container.defaultProps = {
  children: undefined,
};

export default Container;
